/**
 *
 * BIGTINCAN - CONFIDENTIAL
 *
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of BigTinCan Mobile Pty Ltd and its suppliers,
 * if any. The intellectual and technical concepts contained herein are proprietary to BigTinCan Mobile Pty Ltd and its
 * suppliers and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or reproduction of this material is strictly forbidden unless prior
 * written permission is obtained from BigTinCan Mobile Pty Ltd.
 *
 * @package app.bigtincan.dsr
 * @copyright 2010-2020 BigTinCan Mobile Pty Ltd
 * @author Shibu Bhattarai <shibu.bhattarai@bigtincan.com>
 */

import { ApiBase } from '../base';
import { Result, HubFile, Story, BookmarksItem } from '../../model';
import * as PubModal from '../../store/Story/modal';
import { Meeting, MeetingContent } from '../../store/Meeting/types';
import { LoginResponse } from '../../model/api/loginResponse';
import { BrowserStorageKey } from '../../constant/storage';

class HubService extends ApiBase {
  public async exchangeToken(tid: string, token: string): Promise<Result<any>> {
    const result = await this.doPost<any>(`/api/team/token/exchange`, {
      appToken: token,
      tenentId: tid,
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    return result;
    }

    public async getHubToken(token: string): Promise<Result<any>> {
        const time = new Date().getTime();
        const result = await this.doPost<any>(`/connect/hubtokenexchange`, {
            TeamsToken: token,
            State: time.toString()
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return result;
    }


  public async searchContent(term: string, type: string, sort: string): Promise<Result<(HubFile | Story)[]>> {
    // we will need tp remove the static value here
    const result = await this.doGet<HubFile[]>(`/api/contents/${term}?type=${type}&sort=${sort}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
  }
  public async getLoggedInUser(): Promise<Result<HubFile[]>> {
    // we will need tp remove the static value here
    const result = await this.doGet<HubFile[]>(`/api/me`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
  }

  public async getBookmarks(): Promise<Result<BookmarksItem[]>> {
    // we will need tp remove the static value here
    const result = await this.doGet<BookmarksItem[]>(`/api/me/bookmarks`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
  }
  public async getRecommendation(): Promise<Result<Story[]>> {
    // we will need tp remove the static value here
    const result = await this.doGet<Story[]>(`/api/content/recommendation`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
  }

  public async getPopularStories(): Promise<Result<Story[]>> {
    // we will need tp remove the static value here
    const result = await this.doGet<Story[]>(`/api/content/popular`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
  }


  public async saveMeeting(data: any): Promise<Result<Meeting>> {
    // we will need tp remove the static value here
    const result = await this.doPost<any>(`/api/meeting`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
  }

  public async removeContent(meetingId: string, fileId: number[]): Promise<any> {
    return await this.doDelete<any>(`/api/meeting/${meetingId}/${fileId.join(',')}`);
  }

  public async reorderContent(meetingId: string, items: any[]): Promise<any> {
    return await this.doPatch<any>(`/api/meetingcontent/order/${meetingId}`, {
      items
    });
  }

  public async addToMeeting(meetingId: string, data: { items: { fileId: number; storyId: number; }[] } ): Promise<any> {
    const result = await this.doPost<any>(`/api/meeting/${meetingId}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
  }

  public async getMeetingContent(meetingId: string): Promise<any> {
    const result = await this.doGet<any>(`api/meeting/${meetingId}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
  }

  public async getFile(fileId: number): Promise<Result<HubFile>> {
    const result = await this.doGet<HubFile>(`/api/file/${fileId}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
  }

  public async getStory(permId: number): Promise<Result<PubModal.Response<PubModal.Story>>> {
    const result = await this.doGet<PubModal.Response<PubModal.Story>>(`api/story/${permId}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
  }

  public async getNewToken(): Promise<Result<LoginResponse>> {
    // we will need tp remove the static value here
    const result = await this.doPost<LoginResponse>('/connect/refresh', {
      refreshToken: localStorage.getItem(BrowserStorageKey.REFRESH_TOKEN),
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
  }

  public async serverShare(data: {
    langCode: string,
    emails: string[],
    subject: string;
    note: string;
    files: number[]
  }): Promise<Result<LoginResponse>> {
    const result = await this.doPost<LoginResponse>('/api/hubshare',data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
  }
}
const hubService = new HubService();
export default hubService;
